import React from 'react';

import { StyledButtonProps } from './styles';

type CommonButtonProps = {
  rightAddon?: React.ReactElement;
  leftAddon?: React.ReactElement;
  size?: StyledButtonProps['sizeVariant'];
} & Omit<StyledButtonProps, 'color' | 'sizeVariant'>;

type ButtonElementProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  href?: never;
};
type AnchorElementProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  disabled?: never;
};

type ButtonProps = CommonButtonProps &
  (ButtonElementProps | AnchorElementProps);

export default ButtonProps;

export function isAnchor(props: ButtonProps): props is AnchorElementProps {
  return 'href' in props && !('disabled' in props && props.disabled);
}
